import $ from "jquery";
import Handlebars from "handlebars";
import GetUrlParameter from "../utils/getUrlParameter";
import Mark from "./mark.es6.js";

let currentPageNumber;

// mutationConfig enables functionality on changes to defined tags
const mutationConfig = { attributes: true, childList: false, subtree: false };

const mutationCallbackArea = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    var i;    
    for (i = 0; i < mutationsList.length; i++) {
        if (mutationsList[i].type === "attributes") {
            if ($(mutationsList[i].target).hasClass("is-hidden")) {
                //let areaFilter = $("#area-selector").val();
                let areaFilter = [];
                $($("#area-selector option:selected")).each(function () {
                    areaFilter.push($(this).data("id"))
                });

                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has("area_sm")) {
                    let areaQuery = urlParams.get("area_sm").split(" ");
                    if (urlParams.get("area_sm").length < 1) {
                        areaQuery = urlParams.get("area_sm").split("");
                    }
                    let areaChanged = !arrayEquals(areaQuery, areaFilter);
                    if (areaChanged) {
                        insertParam("area_sm", areaFilter.join("+"));
                    }
                } else if ($("#area-selector").val().length > 0) {
                    insertParam("area_sm", areaFilter.join("+"));
                }
            }
        }
    }
};

const mutationCallbackFaqSubject = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    var i;
    for (i = 0; i < mutationsList.length; i++) {
        if (mutationsList[i].type === "attributes") {
            if ($(mutationsList[i].target).hasClass("is-hidden")) {
                //let subjectFilter = $("#faq-subject-selector").val();
                let subjectFilter = [];
                $($("#faq-subject-selector option:selected")).each(function () {
                    subjectFilter.push($(this).data("queryValue"))
                });
                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has("faqsubj")) {
                    let subjectQuery = urlParams.get("faqsubj").split(" ");
                    if (urlParams.get("faqsubj").length < 1) {
                        subjectQuery = urlParams.get("faqsubj").split("");
                    }
                    let subjectChanged = !arrayEquals(subjectQuery, subjectFilter);
                    if (subjectChanged) {
                        insertParam("faqsubj", subjectFilter.join("+"));
                    }
                } else if ($("#faq-subject-selector").val().length > 0) {
                    insertParam("faqsubj", subjectFilter.join("+"));
                }
            }
        }
    }
};

const mutationCallbackDate = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    var i;
    for (i = 0; i < mutationsList.length; i++) {
        if (mutationsList[i].type === "attributes") {
            if (!$(mutationsList[i].target).hasClass("open")) {
                let dateFilter = [];
                if ($("#date-selector").val().length > 0) {
                    dateFilter = $("#date-selector").val().split(" til ");
                }
                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has("date")) {
                    let dateQuery = urlParams.get("date").split(" ");
                    if (urlParams.get("date").length < 1) {
                        dateQuery = urlParams.get("date").split("");
                    }
                    let dateChanged = !arrayEquals(dateQuery, dateFilter);
                    if (dateChanged) {
                        insertParam("date", dateFilter.join("+"));
                    }
                } else if ($("#date-selector").val().length > 0) {
                    insertParam("date", dateFilter.join("+"));
                }
            }
        }
    }
};

const observerArea = new MutationObserver(mutationCallbackArea);
const observerFaqSubject = new MutationObserver(mutationCallbackFaqSubject);
const observerDate = new MutationObserver(mutationCallbackDate);

let executeSearch = null;
let isDefined = (input) => {
    return $(input).length !== 0 && $(input) !== undefined && $(input) !== null;
};

var templateLoader = (function() {
    'use strict';

    // States of loaded templates
    var STATES = { unloaded: 0, loaded: 1, error: -1 };

    // Registations data store
    var registrations = {};

    // Internal class for storing registrations
    var registration = function(key, path, html) {
        this.key = key;
        this.path = path;
        this.html = html;
        if (html) this.state = STATES.loaded; // mark loaded
        else this.state = STATES.unloaded; // mark unloaded
    }

    // Loads the templates html
    var load = function(reg, async) {
        var me = this;

        // only load if in unloaded state                  
        if (reg.state == STATES.unloaded) {
            $.ajax({
                url: reg.path,
                async: async,
                success: function(data) {
                    reg.html = data;
                    reg.state = STATES.loaded;
                    return reg.html
                },
                error: function(data) {
                    reg.state = STATES.error;
                    console.log(data);
                }
            });
        }
    }

    return {
        /** Register a new template
        * @param {object} obj - registration object that contains key and either path or data
        * @param {bool} loadNow - indicates if the template should be syncrhonously now
        */
        register: function(obj, loadSync) {
            // do some validation
            if (!obj.key)
                throw "templates.register requires a key value";
            if (!(obj.path || obj.data))
                throw "templates.register requires a path or data value";

            // do registration
            var reg = new registration(obj.key, obj.path, obj.data);
            registrations[reg.key] = reg;

            // optionally load stuff            
            if (loadSync)
                load(reg, false);
            else
                load(reg, true);
        },
        /** Get a template's html
        * @param {string} key - the template to get
        */
        html: function(key) {
            // check for bad states
            if (!registrations[key]) throw "Template has not been registered";
            if (registrations[key].state == STATES.error) throw "Template load failure";
            var reg = registrations[key];

            // load if necessary
            if (reg.state == STATES.unloaded) {
                load(reg, false);
            }
            return reg.html;
        }
    }
})();


let getCriteriaControls = () => {
    return {
        pageId: $("body").data("pageid"),
        filterId: $("#siteSearchForm").data("filterid"),
        termEntry: $("#search-input"),
        yearSelector: $("#year-selector"),
        workAreaSelector: $("#area-selector"),
        workAreaMultipleSelector: $(".form__field--select-multiple.js--select-multiple #area-selector"),
        subjectSelector: $("#subject-selector"),
        productTypeSelector: $("#product-type-selector"),
        faqSubjectSelector: $("#faq-subject-selector"),
        regionSelector: $("#region-selector"),
        typeSelector: $("#type-selector"),
        typeGroupSelector: $("#typegroup-selector"),
        newsSelector: $("#news-selector"),
        timeSelector: $("#time-selector"),
        flagSelector: $("#flag-selector"),
        departmentSelector: $("#department-selector"),
        letterSelector: $("#letter-selector"),
        rootItemSelector: $("#rootitem-selector"),
        dateSelector: $("#date-selector"),
        sortingSelector: $("#sorting-selector")
    };
};
let createBodyDto = (pageNumber) => {
    let c = getCriteriaControls();

    let output = {
        PageId: c.pageId,
        FilterId: c.filterId,
        Term: isDefined(c.termEntry) && c.termEntry.val() !== "default" ? c.termEntry.val().trim() : null,
        Years: isDefined(c.yearSelector) && c.yearSelector.val() !== "default" ? c.yearSelector.val().split(",") : null,
        WorkAreaIds: isDefined(c.workAreaSelector) && c.workAreaSelector.val() !== "default" ?
            c.workAreaSelector.val().constructor === Array ? c.workAreaSelector.val() : c.workAreaSelector.val().split(",") : null,
        SubjectIds: isDefined(c.subjectSelector) && c.subjectSelector.val() !== "default" ? c.subjectSelector.val().split(",") : null,
        ProductTypeIds: isDefined(c.productTypeSelector) && c.productTypeSelector.val() !== "default" ? c.productTypeSelector.val().split(",") : null,
        FaqSubjects: isDefined(c.faqSubjectSelector) && c.faqSubjectSelector.val() !== "default" ?
            c.faqSubjectSelector.val().constructor === Array ? c.faqSubjectSelector.val() : c.faqSubjectSelector.val().split(",") : null,
        Regions: isDefined(c.regionSelector) && c.regionSelector.val() !== "default" ? c.regionSelector.val().split(",") : null,
        TemplateIds: isDefined(c.typeSelector) && c.typeSelector.val() !== "default" ? c.typeSelector.val().split(",") : null,
        ContentTypeIds: isDefined(c.typeGroupSelector) && c.typeGroupSelector.val() !== "default" ? c.typeGroupSelector.val().split(",") : null, //content type groups translated to content types
        NewsListIds: isDefined(c.newsSelector) && c.newsSelector.val() !== "default" ? c.newsSelector.val().split(",") : null,
        TimeSearch: { Evaluation: isDefined(c.timeSelector) && c.timeSelector.val() !== "default" ? c.timeSelector.val() : null },
        FlagSearch: { Evaluation: isDefined(c.flagSelector) && c.flagSelector.val() !== "default" ? c.flagSelector.val() : null },
        DepartmentNames: isDefined(c.departmentSelector) && c.departmentSelector.val() !== "default" ? c.departmentSelector.val() : null,
        Letters: isDefined(c.letterSelector) && c.letterSelector.val() !== "default" ? c.letterSelector.val().split(",") : null,
        RootItems: isDefined(c.rootItemSelector) && c.rootItemSelector.val() !== "default" ? c.rootItemSelector.val().split(",") : null,
        Date: isDefined(c.dateSelector) && c.dateSelector.val() !== "" ? c.dateSelector.val().split(" til ") : null,
        SortBy: isDefined(c.sortingSelector) && c.dateSelector.val() !== "default" ?  c.sortingSelector.val() : null,
        Language: $("#search-data").data("language"),
        PageSize: $("#search-data").data("page-size"),
        Page: isDefined(pageNumber) ? parseInt(pageNumber) : 1
    };
    return output;
};
let registerPagerEvent = () => {
    $(".page-switcher").click(function (e) {
        e.preventDefault();

        let newPageNumber = $(this).data("page-number");
        if (currentPageNumber !== newPageNumber) {
            executeSearch(newPageNumber);
        }
        $("html, body").animate({
            scrollTop: $(".page-header").offset().top
        },
            1000);
    });
};
let renderPageNumbers = (pagingModel) => {
    if (pagingModel.max === 0) {
        return;
    }
    let pagerTemplate = $("<a />");
    pagerTemplate.attr("href", "#");
    pagerTemplate.addClass("button");
    pagerTemplate.attr("id", "pager");
    for (let i = pagingModel.start; i < pagingModel.end; i += 1) {
        let pager = pagerTemplate.clone();
        pager.attr("id", pager.attr("id") + "_" + i);
        pager.addClass("page-switcher");
        pager.html(i);
        pager.data("page-number", i);
        pager.addClass(pagingModel.current === i ? "is-active" : "");
        pager.appendTo($("#paging-container"));
    }
};
let renderDots = (pagingModel) => {
    let left = $(".pager-start");
    let right = $(".pager-end");

    if (pagingModel.max === 0) {
        left.hide();
        right.hide();
        return;
    }

    if (pagingModel.start === 1) {
        left.hide();
    }

    if (pagingModel.end > pagingModel.max) {
        right.hide();
    }
};
let renderArrows = (pagingModel) => {
    let left = $("#left-arrow");
    let right = $("#right-arrow");

    if (pagingModel.max === 0) {
        left.hide();
        right.hide();
        return;
    }

    if (pagingModel.max === pagingModel.current) {
        right.hide();
    } else {
        right.show();
    }
    if (pagingModel.current === 1) {
        left.hide();
    } else {
        left.show();
    }
};
let buildPagingModel = (data) => {
    const pageNumbersToRender = 5;
    let centerSet = parseInt(pageNumbersToRender / 2);

    let count = data.PageCount > pageNumbersToRender ? pageNumbersToRender : data.PageCount;

    let start;
    if (data.Page < pageNumbersToRender) {
        if (data.Page - centerSet <= 0 || data.PageCount <= pageNumbersToRender) {
            start = 1;
        } else {
            start = data.Page - centerSet;
        }
    } else {
        if (data.Page + centerSet < data.PageCount) {
            start = data.Page - centerSet; //
        } else {
            start = data.PageCount + 1 - pageNumbersToRender;
        }
    }

    return {
        start: start,
        end: count + start,
        current: data.Page,
        max: data.PageCount
    };
};
let populatePaging = (data) => {

    currentPageNumber = data.Page;

    $("#paging-container").empty();
    $(".pager-start").show();
    $(".pager-end").show();

    let model = buildPagingModel(data);
    renderArrows(model);
    renderDots(model);
    renderPageNumbers(model);
    registerPagerEvent();
};
let populateResultList = (data, isFaq) => {
    var externalTemplate = templateLoader.html("resultList");
    let template = Handlebars.compile(externalTemplate);
    $("#search-results-container").html(template(data));
    populatePaging(data);
    if (data.Items.length === 0) {
        let renderngtemplate = $("#template");
        let content = renderngtemplate.find("#no-results").clone();
        content.attr("id", "no-results-markup");
        content.attr("role", "status");
        content.appendTo($("#search-results-container"));
    } else if ($(".form.form--combo.js--page-header-search .resultcount").length > 0){
        let resultCount = $(".form.form--combo.js--page-header-search .resultcount");
        if (data.Page * 10 > data.FacetResults.count) {
            if (data.FacetResults.count === 1) {
                resultCount.html("Viser " + data.FacetResults.count + " af " + data.FacetResults.count + " resultater");
            } else {
                resultCount.html("Viser " + ((data.Page - 1) * 10 + 1) + " - " + data.FacetResults.count + " af " + data.FacetResults.count + " resultater");
            }
        } else {
            resultCount.html("Viser " + ((data.Page - 1) * 10 + 1) + " - " + (data.Page * 10) + " af " + data.FacetResults.count + " resultater");
        }
    }
    document.dispatchEvent(new CustomEvent("document:update"));
};

let search = (pageNumber, preventPushstate) => {
    var isFaqList = $("form.js--page-header-search.faq-search").length != 0;
    var apiAddress = isFaqList ? "/api/faqsearch" : "/api/search";
    $.post(apiAddress, createBodyDto(pageNumber), "json")
        .done(function (data) {
            populateResultList(data, isFaqList);
            let instance = new Mark(document.querySelectorAll(".highLight"));
            let term = $("#search-input").val();
            if (term !== "") {
                instance.mark(term);
            }
            if (!preventPushstate) {
                history.pushState({ page: currentPageNumber }, document.title, document.location.href);
            }
            dispatchEvent(new Event("stickybits:update"));
            if (_paq !== undefined) {
                _paq.push(["setCustomUrl", document.URL + "&search_count=" + data.TotalSearchResults]);
                _paq.push(["trackPageView"]);
            }
        });
};

executeSearch = search;

let arrowClicked = (source) => {
    if (source.attr("id") === "right-arrow") {
        search(currentPageNumber + 1);
    }
    if (source.attr("id") === "left-arrow") {
        search(currentPageNumber - 1);
    }
};

let browserBack = (pageNumber) => {
    search(pageNumber, true);
};

let redirectWithQuery = () => {
    var input = $("#search-input").val();
    var query = removeUrlParameter(location.search, "q");
    query = query.replace("?", "");
    if (query.length > 2) {
        location.search = "q=" + formatQuery(input) + "&" + query;
    } else if(input) {
        location.search = "q=" + formatQuery(input);
    }
    else {
        search();
    }
}

let init = () => {
    var isFaqList = $("form.js--page-header-search.faq-search").length != 0;
    let filters = getCriteriaControls();
    currentPageNumber = $("#search-data").data("page-number");
    
    Handlebars.registerHelper('listItemImage', function (block) {
        var itemImage = document.querySelector("input[name='listItemImage']").value;
        return itemImage;
    });

    Handlebars.registerHelper('showImageFromResultItems', function (block) {
        var inputStr = document.querySelector("input[name='showImageFromResultItems']").value;
        return inputStr;
    });

    Handlebars.registerHelper('defaultImage', function (block) {
        var inputStr = document.querySelector("input[name='defaultImage']").value;
        return inputStr;
    });
    Handlebars.registerHelper('defaultImageSrc', function (block) {
        var inputStr = document.querySelector("input[name='defaultImageSrc']").value;
        return inputStr;
    });
    Handlebars.registerHelper('defaultImageAlt', function (block) {
        var inputStr = document.querySelector("input[name='defaultImageAlt']").value;
        return inputStr;
    });
    Handlebars.registerHelper('limitReached', function (supervisor) {
        if(supervisor.DispentationFromMaxSchoolLimit == true)
            return false;
        return supervisor.SchoolCount > 4;
            
    });
    let templateApiEndpoint = isFaqList ? "/api/Handlebars/FaqResultList" : "/api/Handlebars/ResultList";
    templateLoader.register({ key: "resultList", path: templateApiEndpoint });



    $("#search-command").on("click",
        (e) => {
            e.preventDefault();
            redirectWithQuery();
        });

    $("#siteSearchForm").on("submit",
        (e) => {
            e.preventDefault();
            redirectWithQuery();
        });

    $(filters.yearSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("year", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.workAreaSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("area", $(e.currentTarget).find("option:selected").data("query-value"));
        });

    if ($(".form__field--select-multiple.js--select-multiple #area-selector").length > 0) {
        observerArea.observe($("#area-selector").siblings(".select-multiple-container").find(".dropdown__list-container")[0], mutationConfig);
    }

    if ($(".form__field--select-multiple.js--select-multiple #faq-subject-selector").length > 0) {
        observerFaqSubject.observe($("#faq-subject-selector").siblings(".select-multiple-container").find(".dropdown__list-container")[0], mutationConfig);
    }
    
    $(filters.sortingSelector).on("change",
        (e) => {
            e.preventDefault();
            insertParam("sort", $(e.currentTarget).find("option:selected").val());
        });
    $(filters.subjectSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("subj", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.productTypeSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("pt", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.faqSubjectSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("faqsubj", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.regionSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("region", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.typeSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("type", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.typeGroupSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("tg", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.newsSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("news", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.timeSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("time", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.flagSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("flag", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.departmentSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("dept", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.letterSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("letter", $(e.currentTarget).find("option:selected").data("query-value"));
        });
    $(filters.rootItemSelector).on("change",
        (e) => {
            e.preventDefault();
            //search();
            insertParam("ri", $(e.currentTarget).find("option:selected").data("query-value"));
        });

    $("#left-arrow").on("click",
        function (e) {
            e.preventDefault();
            arrowClicked($(this));
        });
    $("#right-arrow").on("click",
        function (e) {
            e.preventDefault();
            arrowClicked($(this));
        });
    $(".button--clear").on("click",
        function (e) {
            e.preventDefault();
            location.href = location.href.split("?")[0];
        });
    $(window).on("popstate", function (event) {
        event.preventDefault();
        var state = event.originalEvent.state;
        if (state !== null && state !== undefined && state.page !== null) {
            browserBack(state.page);
        } else {
            history.back();
        }
    });

    const q = GetUrlParameter("q");

    if (q !== "") {
        $("#search-input").val(decodeURI(q));
    }

    updateCriteriaControls();

    var searchOnPageLoadEnabled = $("#siteSearchForm").data("search-on-page-load-enabled");

    if (searchOnPageLoadEnabled || location.search !== "") {
        if (location.search.length > 3) {
            $(".button--clear").removeClass("is-hidden");
        }
        search();
    }
};

//Helper function for handling spaces correctly in search result page
function formatQuery(query) {
  return query.replace(" ", "%20");
}

function removeUrlParameter(url, parameter) {    
    var urlparts = url.split("?");
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + "=";
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + "?" + pars.join("&");
        return url;
    } else {
        return url;
    }
}

let updateCriteriaControls = () => {

    const page = GetUrlParameter("page");
    if (page !== "") {
        $("body").data("pageid", page);
    }

    const filterId = GetUrlParameter("filterId");
    if (filterId !== "") {
        $("#siteSearchForm").data("filterid", unescape(filterId));
    }

    const year = GetUrlParameter("year");
    if (year !== "") {
        let option = $('#year-selector option[data-query-value="' + unescape(year) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#year-selector option[data-query-value="default"]').prop('selected', true);
        }
    }

    const date = GetUrlParameter("date");
    if (date !== "") {
        let option = $("#date-selector");
        if (option.length > 0) {
            let dateValue = date.replace("+", " til ");
            $(option).val(dateValue);
        }
        //else {
        //    $('#year-selector option[data-query-value="default"]').prop('selected', true);
        //}
    }

    const area = GetUrlParameter("area");
    if (area !== "") {
        let option = $('#area-selector option[data-query-value="' + unescape(area) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#area-selector option[data-query-value="default"]').prop('selected', true);
        }
    }

    const area_sm = GetUrlParameter("area_sm");
    if (area_sm !== "") {
        const areas = area_sm.split("+");
        areas.forEach(function (item) {
            let input = $('.form__field--select-multiple.js--select-multiple .select-multiple-container input[id="' + unescape(item) + '"]').parents("label");
            if (input.length > 0) {
                $(input).click();
            }
        });
    }

    const subject = GetUrlParameter("subj");
    if (subject !== "") {
        let option = $('#subject-selector option[data-query-value="' + unescape(subject) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#subject-selector option[data-query-value="default"]').prop('selected', true);
        }
    }

    const prodtype = GetUrlParameter("pt");
    if (prodtype !== "") {
        let option = $('#product-type-selector option[data-query-value="' + unescape(prodtype) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#product-type-selector option[data-query-value="default"]').prop('selected', true);
        }
    }

    const faqsubject = GetUrlParameter("faqsubj");
    if (faqsubject !== "") {

        if ($('#faq-subject-selector').prop('multiple')) {
            const subjects = faqsubject.split("+");
            subjects.forEach(function (item) {
                let input = $('.form__field--select-multiple.js--select-multiple .select-multiple-container input[value="' + unescape(item) + '"]').parents("label");
                if (input.length > 0) {
                    $(input).click();
                }
            });
        } else {
            let option = $('#faq-subject-selector option[data-query-value="' + unescape(faqsubject) + '"]');
            if (option.length > 0) {
                $(option).prop('selected', true);
            } else {
                $('#faq-subject-selector option[data-query-value="default"]').prop('selected', true);
            }
        }
    }


    const sorting = GetUrlParameter("sort");
    if (sorting !== "") {
        let option = $('#sorting-selector option[value="' + unescape(sorting) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#sorting-selector option[value="default"]').prop('selected', true);
        }
    } else{
        $('#sorting-selector option[value="published-desc"]').prop('selected', true);
    }


    const region = GetUrlParameter("region");    
    if (region !== "") {
        let option = $('#region-selector option[data-query-value="' + unescape(region) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#region-selector option[data-query-value="default"]').prop('selected', true);
        }
    }

    const type = GetUrlParameter("type");
    if (type !== "") {
        let option = $('#type-selector option[data-query-value="' + unescape(type) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#type-selector option[data-query-value="default"]').prop('selected', true);
        } 
    }

    const typegroup = GetUrlParameter("tg");
    if (typegroup !== "") {
        let option = $('#typegroup-selector option[data-query-value="' + unescape(typegroup) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#typegroup-selector option[data-query-value="default"]').prop('selected', true);
        } 
    }

    const news = GetUrlParameter("news");
    if (news !== "") {
        let option = $('#news-selector option[data-query-value="' + unescape(news) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#news-selector option[data-query-value="default"]').prop('selected', true);
        } 
    }

    const time = GetUrlParameter("time");
    if (time !== "") {
        let option = $('#time-selector option[data-query-value]').filter(function () {
            return this.value.toLowerCase() == unescape(time);
        });
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#time-selector option[data-query-value="default"]').prop('selected', true);
        } 
    }

    const flag = GetUrlParameter("flag");
    if (flag !== "") {
        let option = $('#flag-selector option[data-query-value="' + unescape(flag) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#flag-selector option[data-query-value="default"]').prop('selected', true);
        }   
    }

    const dept = GetUrlParameter("dept");
    if (dept !== "") {
        let option = $('#department-selector option[data-query-value="' + unescape(dept) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#department-selector option[data-query-value="default"]').prop('selected', true);
        }   
    }

    const letter = GetUrlParameter("letter");
    if (letter !== "") {
        let option = $('#letter-selector option[data-query-value="' + unescape(letter) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#letter-selector option[data-query-value="default"]').prop('selected', true);
        }       
    }

    const rootitem = GetUrlParameter("ri");
    if (rootitem !== "") {
        let option = $('#rootitem-selector option[data-query-value="' + unescape(rootitem) + '"]');
        if (option.length > 0) {
            $(option).prop('selected', true);
        } else {
            $('#rootitem-selector option[data-query-value="default"]').prop('selected', true);
        } 
    }
}

let arrayEquals = (a, b) => {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
}


let insertParam = (key, value) => {
    key = escape(key); value = escape(value);

    var kvp = location.search.substr(1).split('&');
    if (kvp == '') {
        location.search = '?' + key + '=' + value;
    }
    else
    {
        var i = kvp.length; var x; while (i--) {
            x = kvp[i].split('=');

            if (x[0] == key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }

        if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

        //this will reload the page, it's likely better to store this until finished
        location.search = kvp.join('&');
    }
}

init();


if ($("#date-selector").length > 0) {
    setTimeout(() => { 
        if ($("#date-selector").length > 0) {
            observerDate.observe($("div.flatpickr-calendar")[0], mutationConfig);
        }
    }, 1000);
}


// WEBPACK FOOTER //
// ./Scripts/Search/listpage.js